<template>
	<auth>
		<vForm v-bind="{loading, error, message}" @submit="login">
			<vItem item="email" label="Email:" v-bind="error">
				<vInput id="email" type="email" v-model="form.email" placeholder="Indtast din e-mail" required/>
			</vItem>
			<vItem item="password" label="Password:" v-bind="error">
				<vInput id="password" type="password" v-model="form.password" placeholder="Indtast din adgangskode" required/>
			</vItem>

			<vButton>Log ind</vButton>
			<a class="forgot" @click="forgotPassword">Glemt din adgangskode?</a>
		</vForm>
	</auth>
</template>

<script>
import {get} from "lodash";
import auth from "@/components/auth.vue";
import {vForm, vItem, vInput, vButton} from "@/components/form";

export default {
	components: {auth, vForm, vItem, vInput, vButton},
	data() {
		return {
			loading: false,
			message: "",
			error: {},

			form: {
				email: "",
				password: ""
			}
		}
	},
	methods: {
		reset() {
			this.loading = false;
			this.message = "";
			this.error = {};
		},

		async login() {
			this.reset();
			this.loading = true;

			try {
				await this.$store.dispatch("user/login", {form: this.form, route: "/"});
			} catch(err) {
				this.error = get(err, "response.data", {});
			}

			this.loading = false;
		},

		async forgotPassword() {
			this.reset();
			this.loading = false;

			try {
				const {data} = await this.$store.dispatch("user/forgotPassword", this.form);
				this.message = data.message;
			} catch(err) {
				this.error = get(err, "response.data", {});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.forgot {
	display: block;
	text-align: center;
	margin-top: 2em;
	color: #007ACE;
	text-decoration: underline;
	font-size: 13px;
}
</style>
